// @flow

import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';

import {
  createGettingStarted,
  createAuthentication,
  createTriggersAndActions,
  createSpecificError,
  createUsingResources,
} from './buildingFirstTimeChildren';

export const buildingFirstTime = (
  isLoggedIn: boolean,
  existingAppOrNewApp: string
) => ({
  value: 'buildingFirstTime',
  // Don't show this option if app selected is already public.
  shouldRender: (context: { [prop: string]: any }) =>
    !context.selectedApp ||
    (context.selectedApp && !context.selectedApp.isPublic),
  zendeskCustomFieldValue: `pcf-${existingAppOrNewApp}-building`,
  label: 'Building my app for the first time',
  child: radio({
    id: 'neworexisting',
    label: 'What part of your app can we help with?',
    zendeskCustomFieldId:
      existingAppOrNewApp === 'new' ? 360044558652 : 360044584552,
    items: [
      createGettingStarted(isLoggedIn, existingAppOrNewApp),
      createAuthentication(isLoggedIn, existingAppOrNewApp),
      createTriggersAndActions(isLoggedIn, existingAppOrNewApp),
      createSpecificError(isLoggedIn, existingAppOrNewApp),
      createUsingResources(isLoggedIn, existingAppOrNewApp), // Only renders if chosen app is CLI
    ],
  }),
});
